import React from "react";
import { SHr, SNavigation, SPage, SPopup, SText, STheme, SView } from "servisofts-component2";
import MDL from "../../MDL";
import PButtom from "../../Components/PButtom";
import Carga_truck from '../../Assets/carga_truck.svg';
import Truck from '../../Assets/truck.svg';
import Coche from '../../Assets/_coche.svg';
import Furgoneta from '../../Assets/_furgoneta.svg';
import Moto from '../../Assets/_moto.svg';
import Verified_icon from '../../Assets/verified_icon.svg';
import { ScrollView } from "react-native-gesture-handler";
import Container from "../../Components/Container";
import { RefreshControl } from "react-native";
export default class root extends React.Component {
    state = {}
    componentDidMount() {
        this.loadData();
    }
    async loadData() {
        try {
            const matriculas = await MDL.checklist.getMatriculasActivas();
            const mat = Object.keys(matriculas)
            const recientes = await MDL.checklist.getRecientes(mat);
            Object.values(matriculas).forEach((lc) => {
                const recientes_ = (recientes ?? []).filter((r) => r.matricula == lc.plate);
                if (recientes_) {
                    lc.checks = recientes_;
                } else {
                    lc.checks = [];
                }
            })
            console.log("recientes", recientes);
            this.setState({ data: Object.values(matriculas), error: null });
        } catch (error) {
            console.error("Error loading data", error);
            this.setState({ error: error ?? "Unknown error", data: [] });
        }
    }
    render() {
        return <SPage title={""} center disableScroll>
            <Container flex>
                <SView flex center style={{ gap: 16, backgroundColor: STheme.color.card, padding: 24, borderRadius: 16, alignItems: "center", }}>
                    <SView col={"xs-12"} center style={{ alignItems: "center" }} row>
                        <Verified_icon width={18} height={18} fill={STheme.color.danger} style={{ marginRight: 8 }} />
                        <SText font='AlbertSans' center fontSize={24} color={STheme.color.secondary}> TIEMPO DE CHECKLIST </SText>
                        <SHr height={10} />
                        <SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
                    </SView>
                    <ScrollView
                        ref={(ref) => { this.questionsScrollRef = ref; }}
                        style={{ flex: 1, width: '100%', alignSelf: 'stretch' }}
                        onScroll={(event) => {
                            this.lastScrollY = event?.nativeEvent?.contentOffset?.y ?? 0;
                        }}
                        scrollEventThrottle={16}
                        contentContainerStyle={{ paddingBottom: 100, flexGrow: 1, flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around', alignItems: 'flex-start' }}
                        keyboardShouldPersistTaps="handled"
                        refreshControl={<RefreshControl refreshing={this.state.refreshing} onRefresh={() => {
                            this.setState({ refreshing: true });
                            this.loadData().then(() => {
                                this.setState({ refreshing: false });
                            });
                        }} />}
                        showsVerticalScrollIndicator>
                        <SHr height={35} />
                        <SView col={"xs-12"} center row style={{ gap: 8 }}>
                            <SView col={"xs-9"} center>
                                <SText font='AlbertSans' bold center fontSize={22} color={STheme.color.text}>Seleccionar Remolques Asignados</SText>
                            </SView>
                            <SHr height={30} />
                            {this.state.error && <SView col={"xs-12"} center>
                                <SText color={STheme.color.danger}>{this.state.error}</SText>
                            </SView>}
                            {!this.state.data && <SText>Cargando...</SText>}
                            {this.state.data && this.state.data.map((item) => {
                                return <MatriculaItem item={item} instance={this} />
                            })}
                        </SView>
                    </ScrollView>
                </SView>
                <SHr h={32} />
            </Container>
        </SPage>
    }
}
const MatriculaItem = ({ item, instance }) => {
    const checks = Array.isArray(item?.checks) ? item.checks : [];
    const check = checks[0] ?? null;
    const completedChecks = checks.filter((checkItem) => String(checkItem?.completado ?? '').trim() === 'exito');
    const pendingChecks = checks.filter((checkItem) => String(checkItem?.completado ?? '').trim() !== 'exito');
    const completedCount = completedChecks.length;
    const pendingCount = pendingChecks.length;
    const useAbbrev = completedCount > 1 || (completedCount === 1 && pendingCount === 1);
    const status = checks.length <= 0
        ? 'none'
        : pendingCount > 0
            ? 'pending'
            : 'done';
    const getStatusText = () => {
        if (status === 'none') return 'Sin checklist';
        const parts = [];
        if (completedCount > 0) {
            parts.push(useAbbrev
                ? `Comp. ${completedCount}`
                : completedCount === 1
                    ? 'Checklist completado'
                    : `Checklist ${completedCount} completados`);
        }
        if (pendingCount > 0) {
            parts.push(useAbbrev
                ? `Pend. ${pendingCount}`
                : pendingCount === 1
                    ? 'Checklist pendiente'
                    : `Checklist ${pendingCount} pendientes`);
        }
        return parts.join(' | ');
    };
    const renderIcon = () => {
        const iconFill = status === 'none' ? "#c5c3c3" : STheme.color.secondary;
        switch (String(item?.descripcion ?? '').trim().toUpperCase()) {
            case 'COCHE':
                return <Coche width={79} height={70} fill={iconFill} />;
            case 'FURGONETA':
            case 'FURGON':
            case 'FRIGO FURGON':
                return <Furgoneta width={64} height={70} fill={iconFill} />;
            case 'LONA AUTOMOCIÓN':
                return <Carga_truck width={99} height={70} fill={iconFill} />;
            case 'RIGIDOS':
                return <Truck width={69} height={70} fill={iconFill} />;
            case 'MOTO':
                return <Moto width={64} height={65} fill={iconFill} />;
            case 'TRACTORA':
                return <Truck width={69} height={70} fill={iconFill} />;
            default:
                return <Carga_truck width={99} height={70} fill={iconFill} />;
        }
    };
    const openCompletedPopup = () => {
        if (status !== 'done' || !check?.id) return;
        SPopup.open({
            key: `checklist_completed_popup_${check.id}`,
            content: (
                <SView col={"xs-12"} center style={{ width: '100%', height: '100%', zIndex: 9999, padding: 22, }}>
                    <SView col={"xs-11"} center style={{ maxWidth: 360, borderRadius: 16, backgroundColor: STheme.color.primary, padding: 22, }}>
                        <SText font='AlbertSans' bold center fontSize={20} color={STheme.color.text}>Checklist completado</SText>
                        <SHr height={8} />
                        <SText font='AlbertSans' center fontSize={14} color={STheme.color.secondary}>¿Qué deseas hacer ahora?</SText>
                        <SHr height={18} />
                        <PButtom center width={"100%"} onPress={() => {
                            SPopup.close(`checklist_completed_popup_${check.id}`);
                            SNavigation.navigate('/checklist/question', { id: check.id, });
                        }}>Ver checklist</PButtom>
                        <SHr height={10} />
                        <PButtom center width={"100%"} onPress={async () => {
                            SPopup.close(`checklist_completed_popup_${check.id}`);
                            await createChecklist(true);
                        }}>Crear nuevo checklist</PButtom></SView>
                </SView>
            ),
        });
    }
    const createChecklist = async (forceNew = false) => {
        let id = check?.id;
        if (forceNew || !check) {
            const resp = await MDL.checklist.crearChecklist({
                matricula: item.plate,
                dni: MDL.usuario.session.sDNI,
                tipo_vehiculo_id: item.tipo_vehiculo_id,
            })
            instance.loadData();
            id = resp.id;
        }
        SNavigation.navigate('/checklist/question', { id: id, });
    }
    const openPendingChecklist = () => {
        const pendingCheck = pendingChecks[0] ?? check;
        if (!pendingCheck?.id) {
            createChecklist();
            return;
        }
        SNavigation.navigate('/checklist/question', { id: pendingCheck.id, });
    }
    return <SView center style={{
        width: 150, height: 150, borderWidth: 2, padding: 4,
        borderRadius: 8,
        borderColor: status === 'done' ? STheme.color.primary : status === 'pending' ? STheme.color.secondary : STheme.color.gray,
        backgroundColor: status === 'done' ? STheme.color.primary : STheme.color.gray,
    }} onPress={() => {
        if (status === 'done') {
            openCompletedPopup();
            return;
        }
        if (status === 'pending') {
            openPendingChecklist();
            return;
        }
        createChecklist();
    }}>
        {renderIcon()}
                <SText width={"90%"} font='AlbertSans' center style={{ textTransform: 'capitalize' }} numberOfLines={1}>{item.descripcion}</SText>
        <SText>{item.plate}</SText>
        {status === 'none' ? (
            <SText color={STheme.color.gray} numberOfLines={1} ellipsizeMode="tail">
                {getStatusText()}
            </SText>
        ) : (
            <SView row center style={{ gap: 6, flexWrap: 'wrap', justifyContent: 'center' }}>
                {completedCount > 0 && (
                    <SText bold color={"#2ECC40"} numberOfLines={1} ellipsizeMode="tail">
                        {useAbbrev
                            ? `Comp. ${completedCount}`
                            : completedCount === 1
                                ? 'Checklist completado'
                                : `Checklist ${completedCount} completados`}
                    </SText>
                )}
                {completedCount > 0 && pendingCount > 0 && (
                    <SText color={STheme.color.gray} numberOfLines={1}>
                        |
                    </SText>
                )}
                {pendingCount > 0 && (
                    <SText bold color="#ff5a52" numberOfLines={1} ellipsizeMode="tail">
                        {useAbbrev
                            ? `Pend. ${pendingCount}`
                            : pendingCount === 1
                                ? 'Checklist pendiente'
                                : `Checklist ${pendingCount} pendientes`}
                    </SText>
                )}
            </SView>
        )}
    </SView>
}